import { useState, useRef } from 'react';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../../services/auth.service.js';
import { data } from '../../config/config.js';
import './NewForgotPassStyle.css'; // Estilos personalizados

export const NewForgotPass = () => {
  const [email, setEmail] = useState('');
  const [captchaValido, setCaptchaValido] = useState(false);
  const captcha = useRef(null);
  const navigate = useNavigate();

  const handleCaptchaChange = () => {
    if (captcha.current.getValue()) {
      setCaptchaValido(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captcha.current.getValue()) {
      Swal.fire('ReCAPTCHA requerido', 'Por favor completa el reCAPTCHA antes de continuar.', 'warning');
      return;
    }

    try {
      Swal.fire({
        title: 'Enviando solicitud...',
        html: 'Por favor espere',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      await requestPasswordReset(email);

      Swal.fire(
        'Solicitud enviada',
        'Se ha enviado un email con instrucciones para resetear su contraseña. Si luego de resetear la clave no podes ingresar a tu cuenta, habla con tu vendedor ya que tu cuenta esta inactiva',
        'success'
      );
      setTimeout(() => navigate('/login'), 4000);
    } catch (error) {
      Swal.fire(
        'Error',
        error.response?.data?.message || 'Error al procesar la solicitud',
        'error'
      );
    }
  };

  return (
    <div className="d-flex justify-content-center mt-3 mb-3 align-items-center">
      <div className="card-3d p-4 shadow-lg">
        <h4 className="text-center mb-4">Recuperar contraseña</h4>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input 
              type="email" 
              className="form-control text-center"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ingrese su email"
              required
            />
          </div>

          <div className="d-flex justify-content-center my-3">
            <ReCAPTCHA
              ref={captcha}
              sitekey={data.sitekey}
              onChange={handleCaptchaChange}
            />
          </div>

          <div className="d-flex justify-content-center">
            <button type="submit" disabled={!captchaValido} className="btn btn-primary px-4">
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
